export { BuilderInfoService } from './builder-info';
export { AvailableLangs, Locale } from './builder-info.constants';
